import { ISDESKTOP } from '../constants/commonConstants';

function main() {
    const mainLink = document.querySelector('.language-selector');

    if (!mainLink) {
        return;
    }

    const wrapper = document.querySelector('.language-selector__wrapper');
    const toCountries = document.querySelectorAll('.language-selector__to-countries');
    const countries = document.querySelectorAll('.language-selector__countries');
    const current = document.querySelectorAll('.language-selector__current');
    const backLinks = document.querySelectorAll('.language-selector__item--back');
    const countryGroupLinks = document.querySelectorAll('.language-selector__item--down');
    const overlay = document.querySelectorAll('.language-selector .nav-overlay')[0];
    const content = document.querySelectorAll('.language-selector__content');

    mainLink.addEventListener('click', () => {
        toggleSelector();
    });

    function toggleSelector() {
        wrapper.classList.toggle('language-selector__wrapper--visible');
        mainLink.classList.toggle('language-selector--open');
        overlay.classList.toggle('is-active');
        mainLink.setAttribute('aria-expanded', mainLink.classList.contains('language-selector--open'));
    }

    // Prevent closing the language selector when the user clicks inside
    content.forEach((contentEl) => {
        contentEl.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    });

    function closeSelector() {
        wrapper.classList.remove('language-selector__wrapper--visible');
        mainLink.classList.remove('language-selector--open');
        overlay.classList.remove('is-active');
        mainLink.setAttribute('aria-expanded', 'false');
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && mainLink.classList.contains('language-selector--open')) {
            setTimeout(() => {
                if (!mainLink.contains(document.activeElement)) {
                    closeSelector();
                }
            }, 0);
        }

        if (e.key === 'Escape' && mainLink.classList.contains('language-selector--open')) {
            closeSelector();
            mainLink.focus();
        }
    });

    const mainHeader = document.getElementsByClassName('main-header')[0];

    if (typeof mainHeader !== 'undefined' && ISDESKTOP) {
        const headerOffset = 48 + 88 + 82; // meta header + nav header
        const collapseTarget = document.querySelector(".trigger-header-collapse");
        const collapseValue = collapseTarget !== null ? (collapseTarget.getBoundingClientRect().top - headerOffset) : 100;

        window.addEventListener('scroll', () => {
            let scrollPosY = window.pageYOffset | document.body.scrollTop;

            if (scrollPosY > collapseValue) {
                closeSelector();
                return;
            }
        });
    }

    toCountries.forEach((toCountriesLink) => {
        toCountriesLink.addEventListener('click', () => {
            showCountries();
        });
    });

    backLinks.forEach((backLink) => {
        backLink.addEventListener('click', () => {
            hideCountries();
        });
    });

    countryGroupLinks.forEach((countryGroupLink) => {
        countryGroupLink.addEventListener('click', (el) => {
            el.target.classList.toggle('language-selector__item--down--open');
            el.target.nextElementSibling.classList.toggle('language-selector__items--open');

            const isExpanded = el.target.classList.contains('language-selector__item--down--open');
            el.target.setAttribute('aria-expanded', String(isExpanded));
        });
    });

    function showCountries() {
        current.forEach((currentEl) => {
            currentEl.classList.add('language-selector__content--hidden');
        });

        countries.forEach((countriesEl) => {
            countriesEl.classList.remove('language-selector__content--hidden');
        });

        const firstFocusable = wrapper.querySelector('.language-selector__countries [tabindex="0"], .language-selector__countries a');
        if (firstFocusable) firstFocusable.focus();
    }

    function hideCountries() {
        current.forEach((currentEl) => {
            currentEl.classList.remove('language-selector__content--hidden');
        });

        countries.forEach((countriesEl) => {
            countriesEl.classList.add('language-selector__content--hidden');
        });

        const firstFocusable = wrapper.querySelector('.language-selector__current [tabindex="0"], .language-selector__current a');
        if (firstFocusable) firstFocusable.focus();
    }
}

main();
